export const initialState = {
    rqsId:0,
    serialNoHistoryResult: [],
    isOpenWarranty:false,
    rqsModalData:[],
    rqsCount:0,
    serialNo:null,
    isSwap:false,
    partChange:[],
    loadingRqs:false,
    swapModalData:{
      rqId:0,
    eid:0,
    srNo:'',
    model:'',
    submodel:'',
    },
    serialInfo:[],
    srNoFilter:[],
    searchEid:null,
    searchSr:'',
    searchWpn:null,
    searchLoad:false,
    
    totalRecords:0,
    swapESr:[],
    loadingEsr:false,
    swapAlert:false,
    swapReqData:{
      currentEntitlementId:0,
      swapEntitlementId:0,
      userId:0,
    },
    wid:0,
    tempRqsId:0
  };
  